// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftRow-module__font-s-10___hmLeM {
  font-size: 10px !important;
}

.DraftRow-module__font-s-12___fws18 {
  font-size: 12px !important;
}

.DraftRow-module__font-s-13___YSkXD {
  font-size: 13px !important;
}

.DraftRow-module__font-s-14___EQqZl {
  font-size: 14px !important;
}

.DraftRow-module__font-s-15___aFLMw {
  font-size: 15px !important;
}

.DraftRow-module__font-s-16___hxHQ3 {
  font-size: 16px !important;
}

.DraftRow-module__font-s-18___ABSXh {
  font-size: 18px !important;
}

.DraftRow-module__font-s-20___IAFM5 {
  font-size: 20px !important;
}

.DraftRow-module__font-s-22___KFqgr {
  font-size: 22px !important;
}

.DraftRow-module__font-s-28____dqA0 {
  font-size: 28px !important;
}

.DraftRow-module__font-w-400___VC0Az {
  font-weight: 400 !important;
}

.DraftRow-module__font-w-500___gLz_f {
  font-weight: 500 !important;
}

.DraftRow-module__font-w-600___Rde3t {
  font-weight: 600 !important;
}

.DraftRow-module__font-w-700___HB_Hz {
  font-weight: 700 !important;
}

.DraftRow-module__p-5___OAlOp {
  padding: 5px !important;
}

.DraftRow-module__p-12___uQN37 {
  padding: 12px !important;
}

.DraftRow-module__p-16___siHva {
  padding: 16px !important;
}

.DraftRow-module__p-30___YQVkl {
  padding: 30px !important;
}

.DraftRow-module__p-b-0___CJaHT {
  padding-bottom: 0 !important;
}

.DraftRow-module__p-b-5___CqAzj {
  padding-bottom: 5px !important;
}

.DraftRow-module__p-b-10___knCAB {
  padding-bottom: 10px !important;
}

.DraftRow-module__p-b-12___bDDvw {
  padding-bottom: 12px !important;
}

.DraftRow-module__p-b-16___onZGo {
  padding-bottom: 16px !important;
}

.DraftRow-module__p-b-18___gmcPL {
  padding-bottom: 18px !important;
}

.DraftRow-module__p-b-20___XtAiz {
  padding-bottom: 20px !important;
}

.DraftRow-module__p-b-25___iAooz {
  padding-bottom: 25px !important;
}

.DraftRow-module__p-b-30___iZDJL {
  padding-bottom: 30px !important;
}

.DraftRow-module__p-b-50___XzYgK {
  padding-bottom: 50px !important;
}

.DraftRow-module__p-t-0___JtjYm {
  padding-top: 0 !important;
}

.DraftRow-module__p-t-12___GL2HR {
  padding-top: 12px !important;
}

.DraftRow-module__p-t-16___oNdf7 {
  padding-top: 16px !important;
}

.DraftRow-module__p-t-18___Vj0h4 {
  padding-top: 18px !important;
}

.DraftRow-module__p-t-20___TMqGY {
  padding-top: 20px !important;
}

.DraftRow-module__p-t-30___UhuaH {
  padding-top: 30px !important;
}

.DraftRow-module__p-t-40___JDzVS {
  padding-top: 40px !important;
}

.DraftRow-module__p-t-50___MnDe7 {
  padding-top: 50px !important;
}

.DraftRow-module__p-l-20___GnVR_ {
  padding-left: 20px !important;
}

.DraftRow-module__p-l-30___e045z {
  padding-left: 30px !important;
}

.DraftRow-module__p-l-40___oVCc7 {
  padding-left: 40px !important;
}

.DraftRow-module__p-r-16___znvWI {
  padding-right: 16px !important;
}

.DraftRow-module__p-r-20___ZLxDv {
  padding-right: 20px !important;
}

.DraftRow-module__p-r-30___sjMxV {
  padding-right: 30px !important;
}

.DraftRow-module__p-r-50___x41Id {
  padding-right: 50px !important;
}

.DraftRow-module__p-r-60___S1dDH {
  padding-right: 60px !important;
}

.DraftRow-module__m-b-1___mXi2w {
  margin-bottom: 1px !important;
}

.DraftRow-module__m-b-2___TtcUn {
  margin-bottom: 2px !important;
}

.DraftRow-module__m-b-6___QEibN {
  margin-bottom: 6px !important;
}

.DraftRow-module__m-b-8___VRYUu {
  margin-bottom: 8px !important;
}

.DraftRow-module__m-b-10___GUZG3 {
  margin-bottom: 10px !important;
}

.DraftRow-module__m-b-14___CctNn {
  margin-bottom: 14px !important;
}

.DraftRow-module__m-b-16___QUJ3T {
  margin-bottom: 16px !important;
}

.DraftRow-module__m-b-20___eoLmJ {
  margin-bottom: 20px !important;
}

.DraftRow-module__m-b-22___ie0ry {
  margin-bottom: 22px !important;
}

.DraftRow-module__m-b-24___PPTlw {
  margin-bottom: 24px !important;
}

.DraftRow-module__m-b-30___gigWw {
  margin-bottom: 30px !important;
}

.DraftRow-module__m-b-32___dIiWc {
  margin-bottom: 32px !important;
}

.DraftRow-module__m-b-40___saO5y {
  margin-bottom: 40px !important;
}

.DraftRow-module__m-t-2___qQ0tr {
  margin-top: 2px !important;
}

.DraftRow-module__m-t-3___dfY1T {
  margin-top: 3px !important;
}

.DraftRow-module__m-t-4___ofG4c {
  margin-top: 4px !important;
}

.DraftRow-module__m-t-5___bBTJt {
  margin-top: 5px !important;
}

.DraftRow-module__m-t-8___fGjQt {
  margin-top: 8px !important;
}

.DraftRow-module__m-t-10___QYPJr {
  margin-top: 10px !important;
}

.DraftRow-module__m-t-15___mQJjE {
  margin-top: 15px !important;
}

.DraftRow-module__m-t-16___CayQA {
  margin-top: 16px !important;
}

.DraftRow-module__m-t-20___IqEBB {
  margin-top: 20px !important;
}

.DraftRow-module__m-t-22___yTsvB {
  margin-top: 22px !important;
}

.DraftRow-module__m-t-30___NYcob {
  margin-top: 30px !important;
}

.DraftRow-module__m-t-32___fN7Hk {
  margin-top: 32px !important;
}

.DraftRow-module__m-l-auto___F4l8l {
  margin-left: auto !important;
}

.DraftRow-module__m-l-4___a3lvw {
  margin-left: 4px !important;
}

.DraftRow-module__m-l-5___QdDE5 {
  margin-left: 5px !important;
}

.DraftRow-module__m-l-6___T5Q9D {
  margin-left: 6px !important;
}

.DraftRow-module__m-l-8___lhbZ_ {
  margin-left: 8px !important;
}

.DraftRow-module__m-l-10___BRiRy {
  margin-left: 10px !important;
}

.DraftRow-module__m-l-16___oLLU2 {
  margin-left: 16px !important;
}

.DraftRow-module__m-l-20___I_Vd7 {
  margin-left: 20px !important;
}

.DraftRow-module__m-l-24___FPrrI {
  margin-left: 24px !important;
}

.DraftRow-module__m-l-30___iqzjT {
  margin-left: 30px !important;
}

.DraftRow-module__m-l-35___YzXQL {
  margin-left: 35px !important;
}

.DraftRow-module__m-l-40___Z_lut {
  margin-left: 40px !important;
}

.DraftRow-module__m-r-8___euMxm {
  margin-right: 8px !important;
}

.DraftRow-module__m-r-10___MOqkS {
  margin-right: 10px !important;
}

.DraftRow-module__m-r-16___OQK5f {
  margin-right: 16px !important;
}

.DraftRow-module__m-r-20___ZxOs1 {
  margin-right: 20px !important;
}

.DraftRow-module__m-r-24___hmGst {
  margin-right: 24px !important;
}

.DraftRow-module__m-r-30___kf006 {
  margin-right: 30px !important;
}

.DraftRow-module__m-r-40___hQLNG {
  margin-right: 40px !important;
}

.DraftRow-module__border-r-3___R0bH0 {
  border-radius: 3px !important;
}

.DraftRow-module__border-r-4___UnUPh {
  border-radius: 4px !important;
}

.DraftRow-module__border-r-6___lPkKo {
  border-radius: 6px !important;
}

.DraftRow-module__border-r-10___MjraV {
  border-radius: 10px !important;
}

.DraftRow-module__border-r-12___U57Fm {
  border-radius: 12px !important;
}

.DraftRow-module__border-r-16___OdtEB {
  border-radius: 16px !important;
}

.DraftRow-module__border-r-50___tek7b {
  border-radius: 50% !important;
}

.DraftRow-module__primary-border___tlomR {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftRow-module__primary-border-b___V5Jcm {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftRow-module__primary-border-t___s_rHB {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftRow-module__primary-border-l___tjHgq {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftRow-module__primary-border-r___v25Xh {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftRow-module__secondary-border___VfrGb {
  border: 1px solid #637768;
}

.DraftRow-module__secondary-border-b___XdwA2 {
  border-bottom: 1px solid #637768;
}

.DraftRow-module__secondary-border-t___PcuuF {
  border-top: 1px solid #637768;
}

.DraftRow-module__secondary-border-l___Y9Sek {
  border-left: 1px solid #637768;
}

.DraftRow-module__secondary-border-r___IM2Su {
  border-right: 1px solid #637768;
}

.DraftRow-module__gap-0___hIr_Y {
  gap: 0 !important;
}

.DraftRow-module__gap-2___DCCfi {
  gap: 2px !important;
}

.DraftRow-module__gap-4___IcWu0 {
  gap: 4px !important;
}

.DraftRow-module__gap-5___QIeYs {
  gap: 5px !important;
}

.DraftRow-module__gap-6___Z6EpM {
  gap: 6px !important;
}

.DraftRow-module__gap-8___Y4i3R {
  gap: 8px !important;
}

.DraftRow-module__gap-10___mnnKP {
  gap: 10px !important;
}

.DraftRow-module__gap-12___IjAdT {
  gap: 12px !important;
}

.DraftRow-module__gap-14___WAwV3 {
  gap: 14px !important;
}

.DraftRow-module__gap-16___hkJHK {
  gap: 16px !important;
}

.DraftRow-module__gap-18___q3Zqb {
  gap: 18px !important;
}

.DraftRow-module__gap-20___MjPJR {
  gap: 20px !important;
}

.DraftRow-module__gap-24___ZO3dT {
  gap: 24px !important;
}

.DraftRow-module__gap-26___YRbh0 {
  gap: 26px !important;
}

.DraftRow-module__gap-30___Xcez2 {
  gap: 30px !important;
}

.DraftRow-module__gap-32___pyxqK {
  gap: 32px !important;
}

.DraftRow-module__gap-40___gSqlv {
  gap: 40px !important;
}

.DraftRow-module__gap-50___NiST2 {
  gap: 50px !important;
}

.DraftRow-module__flex-1___obGsV {
  flex: 1;
}

.DraftRow-module__flex-none___oZVuG {
  flex: none !important;
}

.DraftRow-module__flex-column___KFG6B {
  display: flex;
  flex-direction: column !important;
}

.DraftRow-module__flex-row___JvELH {
  display: flex;
  flex-direction: row !important;
}

.DraftRow-module__vertically-centered___aFTQh {
  display: flex;
  align-items: center !important;
}

.DraftRow-module__horizontally-centered___Khs30 {
  display: flex;
  justify-content: center !important;
}

.DraftRow-module__horizontally-end___ehLea {
  display: flex;
  justify-content: end !important;
}

.DraftRow-module__vertically-start___Otyhh {
  display: flex;
  align-items: start !important;
}

.DraftRow-module__space-between___rwD57 {
  display: flex;
  justify-content: space-between !important;
}

.DraftRow-module__flex-wrap___NAjuN {
  flex-wrap: wrap !important;
}

.DraftRow-module__height-100___JBqNe {
  height: 100%;
}

.DraftRow-module__width-50___YwtaT {
  width: 50% !important;
}

.DraftRow-module__width-100___DH0BJ {
  width: 100%;
}

.DraftRow-module__cursor-pointer___aFjuZ {
  cursor: pointer;
}

.DraftRow-module__cursor-not-allowed___eoVCZ {
  cursor: not-allowed !important;
}

.DraftRow-module__absolute-centered___P3u0I {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DraftRow-module__absolute___M53LH {
  position: absolute;
}

.DraftRow-module__relative___NMzKA {
  position: relative;
}

.DraftRow-module__fixed___qGdjr {
  position: fixed;
}

.DraftRow-module__visible___aiVyt {
  opacity: 1;
}

.DraftRow-module__invisible___vde2V {
  opacity: 0;
}

.DraftRow-module__col-90___Gvieb {
  width: 90% !important;
}

.DraftRow-module__col-auto___W1B56 {
  width: auto !important;
}

.DraftRow-module__medical-tabs___DEWmG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DraftRow-module__medical-table-new___BG7QY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DraftRow-module__medical-table-new___BG7QY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DraftRow-module__medical-table-new___BG7QY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DraftRow-module__medical-table-new___BG7QY::-webkit-scrollbar-track {
  display: none;
}
.DraftRow-module__medical-table-new___BG7QY.DraftRow-module__no-pagination___mN2X8 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DraftRow-module__medical-table-new___BG7QY.DraftRow-module__no-pagination___mN2X8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DraftRow-module__medical-table-new___BG7QY.DraftRow-module__no-pagination___mN2X8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DraftRow-module__medical-table-new___BG7QY.DraftRow-module__no-pagination___mN2X8::-webkit-scrollbar-track {
  display: none;
}

.DraftRow-module__medical-table-empty___HzhJu {
  padding: 14px 40px !important;
}

.DraftRow-module__icon-btn___s1XGk {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DraftRow-module__search-icon___TFbQq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DraftRow-module__disable-select___STGiH {
  user-select: none;
}

.DraftRow-module__break-word___elqPG {
  word-break: break-word;
}

.DraftRow-module__popup-clear-btn___gQ_mf {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DraftRow-module__scroll-m-b-20___kVOkZ {
  scroll-margin-bottom: 20px;
}

.DraftRow-module__container___EXqnB {
  display: flex;
  cursor: pointer;
}
.DraftRow-module__container___EXqnB .DraftRow-module__reason___MfMYi {
  flex: 1;
}
.DraftRow-module__container___EXqnB .DraftRow-module__aside___bGOFB {
  color: #6d7278;
  margin-left: 3em;
}

.DraftRow-module__separator___XtLff {
  width: 96%;
  margin: 1em 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/rows/DraftRow/DraftRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,OAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,gBAAA;AA6pBJ;;AAzpBA;EACE,UAAA;EACA,aAAA;AA4pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  cursor: pointer;\n\n  .reason {\n    flex: 1;\n  }\n\n  .aside {\n    color: get-color(gray, dark);\n    margin-left: 3em;\n  }\n}\n\n.separator {\n  width: 96%;\n  margin: 1em 0;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DraftRow-module__font-s-10___hmLeM`,
	"fontS12": `DraftRow-module__font-s-12___fws18`,
	"fontS13": `DraftRow-module__font-s-13___YSkXD`,
	"fontS14": `DraftRow-module__font-s-14___EQqZl`,
	"fontS15": `DraftRow-module__font-s-15___aFLMw`,
	"fontS16": `DraftRow-module__font-s-16___hxHQ3`,
	"fontS18": `DraftRow-module__font-s-18___ABSXh`,
	"fontS20": `DraftRow-module__font-s-20___IAFM5`,
	"fontS22": `DraftRow-module__font-s-22___KFqgr`,
	"fontS28": `DraftRow-module__font-s-28____dqA0`,
	"fontW400": `DraftRow-module__font-w-400___VC0Az`,
	"fontW500": `DraftRow-module__font-w-500___gLz_f`,
	"fontW600": `DraftRow-module__font-w-600___Rde3t`,
	"fontW700": `DraftRow-module__font-w-700___HB_Hz`,
	"p5": `DraftRow-module__p-5___OAlOp`,
	"p12": `DraftRow-module__p-12___uQN37`,
	"p16": `DraftRow-module__p-16___siHva`,
	"p30": `DraftRow-module__p-30___YQVkl`,
	"pB0": `DraftRow-module__p-b-0___CJaHT`,
	"pB5": `DraftRow-module__p-b-5___CqAzj`,
	"pB10": `DraftRow-module__p-b-10___knCAB`,
	"pB12": `DraftRow-module__p-b-12___bDDvw`,
	"pB16": `DraftRow-module__p-b-16___onZGo`,
	"pB18": `DraftRow-module__p-b-18___gmcPL`,
	"pB20": `DraftRow-module__p-b-20___XtAiz`,
	"pB25": `DraftRow-module__p-b-25___iAooz`,
	"pB30": `DraftRow-module__p-b-30___iZDJL`,
	"pB50": `DraftRow-module__p-b-50___XzYgK`,
	"pT0": `DraftRow-module__p-t-0___JtjYm`,
	"pT12": `DraftRow-module__p-t-12___GL2HR`,
	"pT16": `DraftRow-module__p-t-16___oNdf7`,
	"pT18": `DraftRow-module__p-t-18___Vj0h4`,
	"pT20": `DraftRow-module__p-t-20___TMqGY`,
	"pT30": `DraftRow-module__p-t-30___UhuaH`,
	"pT40": `DraftRow-module__p-t-40___JDzVS`,
	"pT50": `DraftRow-module__p-t-50___MnDe7`,
	"pL20": `DraftRow-module__p-l-20___GnVR_`,
	"pL30": `DraftRow-module__p-l-30___e045z`,
	"pL40": `DraftRow-module__p-l-40___oVCc7`,
	"pR16": `DraftRow-module__p-r-16___znvWI`,
	"pR20": `DraftRow-module__p-r-20___ZLxDv`,
	"pR30": `DraftRow-module__p-r-30___sjMxV`,
	"pR50": `DraftRow-module__p-r-50___x41Id`,
	"pR60": `DraftRow-module__p-r-60___S1dDH`,
	"mB1": `DraftRow-module__m-b-1___mXi2w`,
	"mB2": `DraftRow-module__m-b-2___TtcUn`,
	"mB6": `DraftRow-module__m-b-6___QEibN`,
	"mB8": `DraftRow-module__m-b-8___VRYUu`,
	"mB10": `DraftRow-module__m-b-10___GUZG3`,
	"mB14": `DraftRow-module__m-b-14___CctNn`,
	"mB16": `DraftRow-module__m-b-16___QUJ3T`,
	"mB20": `DraftRow-module__m-b-20___eoLmJ`,
	"mB22": `DraftRow-module__m-b-22___ie0ry`,
	"mB24": `DraftRow-module__m-b-24___PPTlw`,
	"mB30": `DraftRow-module__m-b-30___gigWw`,
	"mB32": `DraftRow-module__m-b-32___dIiWc`,
	"mB40": `DraftRow-module__m-b-40___saO5y`,
	"mT2": `DraftRow-module__m-t-2___qQ0tr`,
	"mT3": `DraftRow-module__m-t-3___dfY1T`,
	"mT4": `DraftRow-module__m-t-4___ofG4c`,
	"mT5": `DraftRow-module__m-t-5___bBTJt`,
	"mT8": `DraftRow-module__m-t-8___fGjQt`,
	"mT10": `DraftRow-module__m-t-10___QYPJr`,
	"mT15": `DraftRow-module__m-t-15___mQJjE`,
	"mT16": `DraftRow-module__m-t-16___CayQA`,
	"mT20": `DraftRow-module__m-t-20___IqEBB`,
	"mT22": `DraftRow-module__m-t-22___yTsvB`,
	"mT30": `DraftRow-module__m-t-30___NYcob`,
	"mT32": `DraftRow-module__m-t-32___fN7Hk`,
	"mLAuto": `DraftRow-module__m-l-auto___F4l8l`,
	"mL4": `DraftRow-module__m-l-4___a3lvw`,
	"mL5": `DraftRow-module__m-l-5___QdDE5`,
	"mL6": `DraftRow-module__m-l-6___T5Q9D`,
	"mL8": `DraftRow-module__m-l-8___lhbZ_`,
	"mL10": `DraftRow-module__m-l-10___BRiRy`,
	"mL16": `DraftRow-module__m-l-16___oLLU2`,
	"mL20": `DraftRow-module__m-l-20___I_Vd7`,
	"mL24": `DraftRow-module__m-l-24___FPrrI`,
	"mL30": `DraftRow-module__m-l-30___iqzjT`,
	"mL35": `DraftRow-module__m-l-35___YzXQL`,
	"mL40": `DraftRow-module__m-l-40___Z_lut`,
	"mR8": `DraftRow-module__m-r-8___euMxm`,
	"mR10": `DraftRow-module__m-r-10___MOqkS`,
	"mR16": `DraftRow-module__m-r-16___OQK5f`,
	"mR20": `DraftRow-module__m-r-20___ZxOs1`,
	"mR24": `DraftRow-module__m-r-24___hmGst`,
	"mR30": `DraftRow-module__m-r-30___kf006`,
	"mR40": `DraftRow-module__m-r-40___hQLNG`,
	"borderR3": `DraftRow-module__border-r-3___R0bH0`,
	"borderR4": `DraftRow-module__border-r-4___UnUPh`,
	"borderR6": `DraftRow-module__border-r-6___lPkKo`,
	"borderR10": `DraftRow-module__border-r-10___MjraV`,
	"borderR12": `DraftRow-module__border-r-12___U57Fm`,
	"borderR16": `DraftRow-module__border-r-16___OdtEB`,
	"borderR50": `DraftRow-module__border-r-50___tek7b`,
	"primaryBorder": `DraftRow-module__primary-border___tlomR`,
	"primaryBorderB": `DraftRow-module__primary-border-b___V5Jcm`,
	"primaryBorderT": `DraftRow-module__primary-border-t___s_rHB`,
	"primaryBorderL": `DraftRow-module__primary-border-l___tjHgq`,
	"primaryBorderR": `DraftRow-module__primary-border-r___v25Xh`,
	"secondaryBorder": `DraftRow-module__secondary-border___VfrGb`,
	"secondaryBorderB": `DraftRow-module__secondary-border-b___XdwA2`,
	"secondaryBorderT": `DraftRow-module__secondary-border-t___PcuuF`,
	"secondaryBorderL": `DraftRow-module__secondary-border-l___Y9Sek`,
	"secondaryBorderR": `DraftRow-module__secondary-border-r___IM2Su`,
	"gap0": `DraftRow-module__gap-0___hIr_Y`,
	"gap2": `DraftRow-module__gap-2___DCCfi`,
	"gap4": `DraftRow-module__gap-4___IcWu0`,
	"gap5": `DraftRow-module__gap-5___QIeYs`,
	"gap6": `DraftRow-module__gap-6___Z6EpM`,
	"gap8": `DraftRow-module__gap-8___Y4i3R`,
	"gap10": `DraftRow-module__gap-10___mnnKP`,
	"gap12": `DraftRow-module__gap-12___IjAdT`,
	"gap14": `DraftRow-module__gap-14___WAwV3`,
	"gap16": `DraftRow-module__gap-16___hkJHK`,
	"gap18": `DraftRow-module__gap-18___q3Zqb`,
	"gap20": `DraftRow-module__gap-20___MjPJR`,
	"gap24": `DraftRow-module__gap-24___ZO3dT`,
	"gap26": `DraftRow-module__gap-26___YRbh0`,
	"gap30": `DraftRow-module__gap-30___Xcez2`,
	"gap32": `DraftRow-module__gap-32___pyxqK`,
	"gap40": `DraftRow-module__gap-40___gSqlv`,
	"gap50": `DraftRow-module__gap-50___NiST2`,
	"flex1": `DraftRow-module__flex-1___obGsV`,
	"flexNone": `DraftRow-module__flex-none___oZVuG`,
	"flexColumn": `DraftRow-module__flex-column___KFG6B`,
	"flexRow": `DraftRow-module__flex-row___JvELH`,
	"verticallyCentered": `DraftRow-module__vertically-centered___aFTQh`,
	"horizontallyCentered": `DraftRow-module__horizontally-centered___Khs30`,
	"horizontallyEnd": `DraftRow-module__horizontally-end___ehLea`,
	"verticallyStart": `DraftRow-module__vertically-start___Otyhh`,
	"spaceBetween": `DraftRow-module__space-between___rwD57`,
	"flexWrap": `DraftRow-module__flex-wrap___NAjuN`,
	"height100": `DraftRow-module__height-100___JBqNe`,
	"width50": `DraftRow-module__width-50___YwtaT`,
	"width100": `DraftRow-module__width-100___DH0BJ`,
	"cursorPointer": `DraftRow-module__cursor-pointer___aFjuZ`,
	"cursorNotAllowed": `DraftRow-module__cursor-not-allowed___eoVCZ`,
	"absoluteCentered": `DraftRow-module__absolute-centered___P3u0I`,
	"absolute": `DraftRow-module__absolute___M53LH`,
	"relative": `DraftRow-module__relative___NMzKA`,
	"fixed": `DraftRow-module__fixed___qGdjr`,
	"visible": `DraftRow-module__visible___aiVyt`,
	"invisible": `DraftRow-module__invisible___vde2V`,
	"col90": `DraftRow-module__col-90___Gvieb`,
	"colAuto": `DraftRow-module__col-auto___W1B56`,
	"medicalTabs": `DraftRow-module__medical-tabs___DEWmG`,
	"medicalTableNew": `DraftRow-module__medical-table-new___BG7QY`,
	"noPagination": `DraftRow-module__no-pagination___mN2X8`,
	"medicalTableEmpty": `DraftRow-module__medical-table-empty___HzhJu`,
	"iconBtn": `DraftRow-module__icon-btn___s1XGk`,
	"searchIcon": `DraftRow-module__search-icon___TFbQq`,
	"disableSelect": `DraftRow-module__disable-select___STGiH`,
	"breakWord": `DraftRow-module__break-word___elqPG`,
	"popupClearBtn": `DraftRow-module__popup-clear-btn___gQ_mf`,
	"scrollMB20": `DraftRow-module__scroll-m-b-20___kVOkZ`,
	"container": `DraftRow-module__container___EXqnB`,
	"reason": `DraftRow-module__reason___MfMYi`,
	"aside": `DraftRow-module__aside___bGOFB`,
	"separator": `DraftRow-module__separator___XtLff`
};
module.exports = ___CSS_LOADER_EXPORT___;
